import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';

import { PillInputs } from './interfaces/pill-inputs.interface';
import { PILL_INPUTS } from './providers/injection-token.provider';

@Component({
    selector: 'mapp-pill',
    templateUrl: './pill.component.html',
    styleUrls: ['./pill.component.scss'],
    standalone: false,
})
export class PillComponent implements OnInit {
    @Input() text!: PillInputs['text'];

    @Input() colors!: PillInputs['colors'];

    @Output() close: EventEmitter<string> = new EventEmitter();

    injectedInputs: PillInputs;

    styles: string;

    /**
     *
     */
    constructor() {
        this.injectedInputs = inject(PILL_INPUTS);
    }

    /**
     *
     */
    ngOnInit(): void {
        if (!this.text) {
            this.text = this.injectedInputs?.text;
        }

        if (this.colors || this.injectedInputs?.colors) {
            const colors = this.colors || this.injectedInputs?.colors;

            if (colors) {
                this.styles = colors.font ? `color: ${colors.font};` : '';
                this.styles += colors.borderColor ? `border-color: ${colors.borderColor};` : '';
                this.styles += colors.background ? `background: ${colors.background};` : '';
            }
        }
    }

    /**
     *
     */
    handleClose() {
        if (this.close) {
            this.close.emit(this.text);
        }
    }
}
